import { render, staticRenderFns } from "./3DStylize.vue?vue&type=template&id=2f344589&scoped=true&"
import script from "./3DStylize.vue?vue&type=script&lang=js&"
export * from "./3DStylize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f344589",
  null
  
)

export default component.exports